import { render, staticRenderFns } from "./DineInStoreReviewManagement.vue?vue&type=template&id=494516dd"
import script from "./DineInStoreReviewManagement.vue?vue&type=script&lang=js"
export * from "./DineInStoreReviewManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports